import { GrDialog, GrDialogProps, GrStack, GrTypography } from "@jnpmedi/grebob";
import { isMobileDevice, MvnMessage } from "@newLibs/utils";
import { UseBoolean } from "@newHooks/common/useBoolean";
import { DOCS_DOCUMENT_LANG, DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";
import { DocumentSignType } from "@maven-rest/docs/DocumentSign.dto";

interface SignDeclineDialogProps {
  open: UseBoolean;
  documentSignType: DocumentSignType;
  size?: GrDialogProps["size"];
  onConfirm: () => void;
}

export function SignDeclineDialog({ open, documentSignType, size = "xs", onConfirm }: SignDeclineDialogProps) {
  const handleDialogClose = () => {
    open.onFalse();
  };

  const handleDialogConfirm = () => {
    onConfirm();
    handleDialogClose();
  };

  return (
    <GrDialog
      title={resolveDialogTitle(documentSignType)}
      open={open.value}
      onClose={handleDialogClose}
      onConfirm={handleDialogConfirm}
      confirmButton={{
        children: MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_COMMON_DECLINE_NOUN),
        color: "red",
      }}
      cancelButton={{ children: MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_COMMON_CANCEL_NOUN) }}
      size={isMobileDevice() ? "mobile" : size}
    >
      <GrStack flexDirection="column" gap={8}>
        <GrTypography type="Content.Body03" color="grey070">
          {MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_DECLINE_CONFIRM)}
        </GrTypography>
        <GrTypography type="Content.Subtitle03" color="grey070">
          {MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_DECLINE_WARNING)}
        </GrTypography>
      </GrStack>
    </GrDialog>
  );
}

function resolveDialogTitle(documentSignType: DocumentSignType): string {
  return MvnMessage(
    documentSignType === DocumentSignType.EConsent
      ? DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_DECLINE_BUTTON
      : DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DECLINE_BUTTON
  );
}
